import React from 'react'

/* Cards de analisis previo (sin IA), compartidas por los flujos que muestran
   triage/formsDraft antes de pedir confirmacion al usuario. */
export function FormsDraftCard({ d, open = false, compact = false }) {
  return (
    <details
      open={open}
      className="bia-cat"
      style={{ margin: '2px 0 6px', padding: '6px 10px', background: 'var(--brand-soft)', borderRadius: 8, border: '1px solid var(--border)' }}
    >
      <summary>
        🧩 Formularios detectados (sin IA) — <b>{d.stats.forms}</b> form(s) - <b>{d.stats.campos}</b> elementos
        {d.stats.botones ? (
          <span className="bia-badge ok" style={{ marginLeft: 6 }}>
            {d.stats.botones} botón(es) → actions
          </span>
        ) : null}
        {d.stats.menus ? (
          <span className="bia-badge warn" style={{ marginLeft: 6 }}>
            {d.stats.menus} menú(s)
          </span>
        ) : null}
      </summary>
      <div style={{ fontSize: compact ? 11 : 12, marginTop: 6, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
        {d.forms.map((f, i) => (
          <div key={i} style={{ marginBottom: 6 }}>
            <div>
              <strong>«{f.title || '(sin título)'}»</strong> - tipo: <code>{f.windowType}</code> - {f.totalFields} elementos
            </div>
            <ul style={{ margin: '4px 0', paddingLeft: 18 }}>
              {f.fields.map((fl, j) => (
                <li key={j}>
                  {fl.control === 'button' ? (
                    <>
                      🔘 <b>{fl.label}</b> <span style={{ color: 'var(--muted)' }}>→ candidato a action</span>
                    </>
                  ) : fl.control === 'checkbox_group' ? (
                    <>☑ {(fl.miembros || []).join(' - ')}</>
                  ) : (
                    <>
                      <code>[{fl.variable}]</code> «{fl.label}» - {fl.control}
                      {fl.mandatory ? <b>*</b> : null}
                      {fl.opciones ? <span style={{ color: 'var(--muted)' }}> - {fl.opciones.length} opciones</span> : null}
                      {fl.rol ? <span style={{ color: fl.rol === 'user_input' ? 'var(--brand-dark)' : '#b07b1a' }}> - {fl.rol}</span> : null}
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
        {d.roles && d.roles.unused ? (
          <div style={{ color: 'var(--muted)' }}>{d.roles.unused} variables sin uso real (no se generan campos)</div>
        ) : null}
      </div>
    </details>
  )
}

export function TriageCard({ t, open = false, compact = false }) {
  const tone = t.nivel.startsWith('R1') || t.nivel.startsWith('R2') ? 'ok' : t.nivel.startsWith('R3') ? 'warn' : 'err'
  return (
    <details
      open={open}
      className="bia-cat"
      style={{ margin: '2px 0 6px', padding: '6px 10px', background: 'var(--brand-soft)', borderRadius: 8, border: '1px solid var(--border)' }}
    >
      <summary>
        🔎 Análisis previo (sin IA) — <span className={`bia-badge ${tone}`}>{t.nivel}</span>
        {t.sensibles.length ? (
          <span className="bia-badge err" style={{ marginLeft: 6 }}>
            ⚠ {t.sensibles.length} sensibles
          </span>
        ) : null}
        {t.incompleto ? (
          <span className="bia-badge warn" style={{ marginLeft: 6 }}>
            fuente incompleto
          </span>
        ) : null}
      </summary>
      <div style={{ fontSize: compact ? 11 : 12, marginTop: 6, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
        <p style={{ margin: '4px 0' }}>{t.resumen}</p>
        <div>
          <strong>Comandos → clase → API destino:</strong>
        </div>
        <ul style={{ margin: '4px 0', paddingLeft: compact ? 14 : 18 }}>
          {t.comandos.map((c, i) => (
            <li key={i} style={{ marginBottom: compact ? 5 : 0 }}>
              <code>{c.cmd}</code>
              {compact ? (
                <div style={{ paddingLeft: 10, marginTop: 2 }}>
                  → {c.clase} → <span style={{ color: c.gap ? '#b03030' : 'var(--brand-dark)' }}>{c.api}</span>
                </div>
              ) : (
                <> → {c.clase} → <span style={{ color: c.gap ? '#b03030' : 'var(--brand-dark)' }}>{c.api}</span></>
              )}
            </li>
          ))}
        </ul>
        {t.sensibles.length ? (
          <>
            <div>
              <strong>Campos sensibles (PCI/PII):</strong>
            </div>
            <ul style={{ margin: '4px 0', paddingLeft: 18 }}>
              {t.sensibles.map((s, i) => (
                <li key={i}>
                  <code>[{s.campo}]</code> <b>{s.tipo}</b>: {s.detalle}
                </li>
              ))}
            </ul>
          </>
        ) : null}
        {t.huecos.definesSinUso.length ? (
          <p style={{ margin: '4px 0' }}>
            <strong>Defines sin uso ({t.huecos.definesSinUso.length}):</strong> {t.huecos.definesSinUso.slice(0, 12).join(', ')}
            {t.huecos.definesSinUso.length > 12 ? '…' : ''}
          </p>
        ) : null}
        {t.huecos.dependencias.length ? (
          <p style={{ margin: '4px 0' }}>
            <strong>Dependencias externas:</strong> {t.huecos.dependencias.join(', ')}
          </p>
        ) : null}
        {t.gaps.length ? (
          <p style={{ margin: '4px 0' }}>
            <strong>Sin endpoint dedicado (hoy: executeCommand + allowlist):</strong> {t.gaps.join(' - ')}
          </p>
        ) : null}
      </div>
    </details>
  )
}
